import { Box, Grid, Typography, Button, Link } from "@mui/material";
import { rankedTableStyles } from "./ranked-table.styles";
import Image from "next/image";
import { clsx } from "../../../utils";
import { Showable } from "../../utils";

interface RankedTableProps {
  children: React.ReactNode[];
  scoreName?: string;
  link?: string;
  bannerImage?: string;
}

export const RankedTable = ({children, scoreName, link, bannerImage}: RankedTableProps) => (
    <Box sx={rankedTableStyles['wrapper']}>
      <Grid container sx={clsx(rankedTableStyles['head'], {
        width: scoreName ? '814px' : '633px',
      })}>
        <Grid item xs={2}>Place</Grid>
        <Grid item xs={scoreName ? 4 : 5}>Community</Grid>
        <Grid item xs={4}>Location</Grid>
        {scoreName ? (
          <Grid item xs={2}>{scoreName}</Grid>
        ) : <Grid item xs={1}></Grid>}
      </Grid>
        {children}
      <Showable show={!!bannerImage}>
        <Box
          sx={clsx(rankedTableStyles['bannerWrapper'], {
            width: scoreName ? '814px' : '633px',
          })}
        >
          <Box sx={clsx(rankedTableStyles['bannerImageWrapper'])}>
            <Image src={bannerImage!} alt="banner image" width={600} height={38} />
          </Box>
          <Box
            sx={clsx(rankedTableStyles['bannerTextWrapper'])}
          >
            <Typography sx={clsx(rankedTableStyles['bannerTitle'])}>
              Already have a community?
            </Typography>
            <Link href={link} target="_blank">
              <Button sx={clsx(rankedTableStyles['bannerBtn'])}>
								See my ranking
              </Button>
            </Link>
          </Box>
        </Box>
      </Showable>
    </Box>
  )
